import React from 'react';
import { Link } from 'react-router';
import { Repeat } from 'lucide-react';
import { RetweetIndicatorWrapper } from './SocialHeader.styles';
/**
 * 리트윗 표시 컴포넌트
 * 트윗이 리트윗된 경우 상단에 표시됩니다.
 */ const RetweetIndicator = ({ retweetAuthor })=>{
    return /*#__PURE__*/ React.createElement(RetweetIndicatorWrapper, null, /*#__PURE__*/ React.createElement(Repeat, {
        className: "h-4 w-4"
    }), /*#__PURE__*/ React.createElement(Link, {
        to: `/user/${retweetAuthor.username}`,
        className: "hover:underline font-semibold"
    }, retweetAuthor.name), /*#__PURE__*/ React.createElement("span", null, "님이 리트윗했습니다"));
};
export default RetweetIndicator;
